import config from 'config';

const baseURL = config.apiPath;

const processFetch = (res) =>
  Promise.all([res.ok, res.json()])
    .then(([ok, response]) => {
      if (!ok) {
        return Promise.reject(response);
      }
      return { data: response };
    });

const request = method => async (path, body = {}) => {
  let option = {
    method,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
  };
  if (method !== 'GET') {
    option = { ...option, body: JSON.stringify(body) };
  }
  return fetch(`${baseURL}${path}`, option)
    .then(processFetch);
};

export default {
  get: request('GET'),
  post: request('POST'),
  put: request('PUT'),
  delete: request('DELETE'),
};



// WEBPACK FOOTER //
// ./src/utils/api.js